import {Controller} from "stimulus"
import $ from 'jquery';
import flatpickr from "flatpickr";
import {Spanish} from "flatpickr/dist/l10n/es";
import {Russian} from "flatpickr/dist/l10n/ru";
import {French} from "flatpickr/dist/l10n/fr";
import {Italian} from "flatpickr/dist/l10n/it";
import {German} from "flatpickr/dist/l10n/de";
import {Portuguese} from "flatpickr/dist/l10n/pt";
import {MandarinTraditional} from "flatpickr/dist/l10n/zh-tw";
import {english} from "flatpickr/dist/l10n/default";
import {disable_dates} from "./preferences_controller";
import {setSessionVar} from "./sessionStorage_controller";
import {create_array_for_product} from "./b2b_controller";

let date_disabled = [];
let flatpick_lang;

export default class extends Controller {

    connect() {
        let safari_date_group;
        safari_date_group = $('#safari_date_group');

        switch (I18n.locale) {
            case 'es':
                flatpick_lang = Spanish;
                break;
            case 'ru':
                flatpick_lang = Russian;
                break;
            case 'fr':
                flatpick_lang = French;
                break;
            case 'it':
                flatpick_lang = Italian;
                break;
            case 'de':
                flatpick_lang = German;
                break;
            case 'pt':
                flatpick_lang = Portuguese;
                break;
            case 'ch':
                flatpick_lang = MandarinTraditional;
                break;
            case 'en':
                flatpick_lang = english;
                break;
        }

        disable_dates().then(
            dd => {
                date_disabled = dd;
            }
        )

        flatpickr(safari_date_group, {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            disable: date_disabled,
            // minDate: new Date().fp_incr(parseInt(product_type[2])),
            minDate: new Date().fp_incr(3),
            maxDate: new Date().fp_incr(90),
            locale: flatpick_lang
        });
        safari_date_group.on('change', function (e) {
            /* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION */
            setSessionVar('from_date', e.target.value, 'add', true, false).then(
                from => {
                    create_array_for_product('from_date', from.value);
                }
            );
            setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                to => {
                    create_array_for_product('to_date', to.value);
                }
            );
        })

        flatpickr("#disable_date_from", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            minDate: new Date(),
            locale: flatpick_lang
        });
        flatpickr("#from", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d ",
            locale: flatpick_lang
        });
        flatpickr("#from_np", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d ",
            minDate: new Date(),
            locale: flatpick_lang
        });
        flatpickr("#disable_date_to", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            minDate: new Date(),
            locale: flatpick_lang
        });
        flatpickr("#to", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            locale: flatpick_lang
        });
        flatpickr("#to_np", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            minDate: new Date(),
            locale: flatpick_lang
        });
        flatpickr("#init_date", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            minDate: new Date(),
            locale: flatpick_lang
        });
        flatpickr("#finish_date", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            minDate: new Date(),
            locale: flatpick_lang
        });
        flatpickr("#created_at_init", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            maxDate: new Date(),
            locale: flatpick_lang
        });
        flatpickr("#created_at_finish", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            maxDate: new Date(),
            locale: flatpick_lang
        });
    }

    setDataTo(e) {
        let input_target = $('#' + e.target.dataset.target)[0];
        let value = e.target.value;
        let type = e.target.dataset.type
        let hours = '';

        switch (type) {
            case 'from':
                hours = '00:00:00'
                break;
            case 'to':
                hours = '23:59:59'
                break;

        }

        input_target.value = `${value} ${hours}`;
    }
}